<template>
	<Tooltip>
		<template #trigger>
			<div class="flex rounded bg-won-green text-white">
				<div class="flex items-center gap-1.5 border-r border-white px-3 py-2">
					<EyeIcon
						class="size-5"
					/>
					<span class="font-base font-bold">View only</span>
				</div>
                
				<div class="flex-center p-2.5">
					<ChevronDownIcon
						class="size-4 align-middle"
					/>
				</div>
			</div>
		</template>
        
		<template #floating-content>
			<div class="max-w-[281px] bg-white px-4 py-2 text-[14px] leading-[20px] shadow-float-select">
				<p>
					You can only <span class="bold">view</span> this document.<br />
    
					Ask the owner for edit access. (Coming Soon!)</p>
			</div>
		</template>
	</Tooltip>
</template>

<script setup>
import { EyeIcon, ChevronDownIcon } from '@heroicons/vue/24/solid';
import Tooltip from '../library/tooltip.vue';
</script>
